import { render } from "./PrintDialog.vue?vue&type=template&id=8385c3de"
import script from "./PrintDialog.vue?vue&type=script&lang=js"
export * from "./PrintDialog.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__